import React from "react";
import axios from "axios";
import TextInput from "../../../components/common/inputs/textInput";
import SelectInput from "../../../components/common/inputs/selectInput";
import ToggleInput from "../../../components/common/inputs/toggleInput";
import ModalManager from "../../../components/common/modal/ModalManager";
import NotificationManager from "../../../utils/notificationManager";

import Loading from "../../../components/common/loading";

import RowList from "../../../components/common/rowList";
import DeviceLogChart from "../../../components/devices/deviceLogChart";
import openOutletGroupModal from "../../../components/devices/openOutletGroupModal";



export default class DevicePageOutletPage extends React.Component {
  initialState = {
    outletName: "",
    pwrOnState: "",
    customRebootTimeEnabled: false,
    customRebootTime: 0,
    state: "ON",
    customfield1: "",
    customfield2: "",
    saving: false,
    hasChanges: false,
    addGroupSelection: "",
    groupMutations: {},
  };

  state = {
    ...this.initialState,
  };
  async componentDidMount() {
    if (this.props.outletId) {
      this.prepopulateOutletInfo(this.props);
    }
    this.ensureGlobalOutletGroupsLoaded();
  }

  prepopulateOutletInfo = (props = this.props) => {
    const { outlets = [], outletId } = props;

    if (!outletId) {
      this.setState({ ...this.initialState });
      return;
    }

    const outlet = outlets.find((entry) => entry.outlet_id == outletId);

    if (outlet) {
      this.setState({
        outletName: outlet.outletName || "",
        pwrOnState: outlet.pwrOnState || "",
        customRebootTimeEnabled: Boolean(outlet.customRebootTimeEnabled),
        customRebootTime:
          outlet.customRebootTime !== undefined && outlet.customRebootTime !== null
            ? outlet.customRebootTime
            : 0,
        state: outlet.state || "ON",
        customfield1: outlet.customfield1 || "",
        customfield2: outlet.customfield2 || "",
        saving: false,
        hasChanges: false,
      });
    }
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.outletId !== this.props.outletId ||
      (prevProps.outlets !== this.props.outlets && !this.state.hasChanges)
    ) {
      this.prepopulateOutletInfo(this.props);
    }
    if (
      prevProps.resources?.groupsLoaded !== this.props.resources?.groupsLoaded &&
      !this.props.resources?.groupsLoaded &&
      !this.props.resources?.groupsLoading
    ) {
      this.ensureGlobalOutletGroupsLoaded();
    }
  }
  ensureGlobalOutletGroupsLoaded = () => {
    const { resources = {}, fetchResource } = this.props;
    if (!resources.groupsLoaded && !resources.groupsLoading && fetchResource) {
      fetchResource("groups");
    }
  };

  openOutletGroupsModal = (outlet) => {
    const { resources = {}, fetchResource } = this.props;
    openOutletGroupModal({
      outlet,
      groups: resources.groups || [],
      refreshGroups: () => fetchResource?.("groups"),
    });
  };

  getOutletGroupsForOutlet = (outletId) => {
    const { resources = {} } = this.props;
    const outletIdStr = String(outletId);
    return (resources.groups || [])
      .filter(
        g =>
          g.groupType === "outlets" &&
          Array.isArray(g.items) &&
          g.items.some(item => String(item) === outletIdStr)
      );
  };

  getOutletGroupNames = (outletId) => {
    return this.getOutletGroupsForOutlet(outletId)
      .map(g => g.name || g.groupName)
      .filter(Boolean);
  };

  getAvailableOutletGroups = (outletId) => {
    const { resources = {} } = this.props;
    const outletIdStr = String(outletId);
    return (resources.groups || []).filter(
      g =>
        g.groupType === "outlets" &&
        (!Array.isArray(g.items) ||
          !g.items.some(item => String(item) === outletIdStr))
    );
  };

  isGroupMutating = groupId =>
    Boolean(this.state.groupMutations?.[groupId]);

  handleGroupSelectChange = (groupId) => {
    if (!groupId) return;
    this.setState({ addGroupSelection: "" });
    this.mutateGroupMembership(groupId, "add");
  };

  handleGroupRemove = (groupId) => {
    if (!groupId) return;
    this.mutateGroupMembership(groupId, "remove");
  };

  mutateGroupMembership = async (groupId, action) => {
    const { outletId } = this.props;
    if (!groupId || !outletId) {
      return;
    }
    this.setState(prev => ({
      groupMutations: { ...prev.groupMutations, [groupId]: action },
    }));
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("token"),
    };
    const endpoint = action === "add" ? "addOutlet" : "removeOutlet";
    const successMessage =
      action === "add"
        ? "Outlet added to group"
        : "Outlet removed from group";
    try {
      await axios.post(
        `/v1/groups/${groupId}/${endpoint}`,
        {
          outletIds: [String(outletId)],
        },
        { headers }
      );
      NotificationManager.success(successMessage);
      this.props.fetchResource?.("groups");
    } catch (error) {
      console.error(error);
      NotificationManager.alert(
        error?.response?.data?.message ||
          `Unable to ${
            action === "add" ? "add outlet to" : "remove outlet from"
          } the group right now.`
      );
    } finally {
      this.setState(prev => {
        const next = { ...prev.groupMutations };
        delete next[groupId];
        return { groupMutations: next };
      });
    }
  };

  renderGroupBadges = names => {
    if (!Array.isArray(names) || names.length === 0) {
      return <span style={{ color: "#9ca3af" }}>None</span>;
    }
    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
        {names.map(name => (
          <span
            key={name}
            style={{
              padding: "2px 8px",
              borderRadius: "999px",
              background: "#e2e8f0",
              fontSize: "12px",
              color: "#1f2933",
            }}
          >
            {name}
          </span>
        ))}
      </div>
    );
  };
  editOutletInfo = (outlet, field, fieldName, options) => {
    ModalManager.confirm(
      "",
      `Outlet ${outlet.id}`,
      "",
      (submitted, close) => {
        if (submitted) {
          close();
        }
      },
      ({ close }) => (
        <EditOutletForm
          updateOutlet={this.props.updateOutlet}
          outlet={outlet}
          close={close}
          field={field}
          fieldName={fieldName}
          options={options}
        />
      ),
      true,
      true
    );
  };
  onSave = () => {
    this.setState({
      saving: true,
    });
    this.props.updateOutlet(this.props.outletId, {
      outletName: this.state.outletName,
      pwrOnState: this.state.pwrOnState,
      customRebootTimeEnabled: this.state.customRebootTimeEnabled,
      customRebootTime: this.state.customRebootTime,
      customfield1: this.state.customfield1,
      customfield2: this.state.customfield2,
    }, (err, res) => {
      if (err) {
        console.log(err);
        this.setState({
          saving: false,
        });
      } else {
        this.setState({
          saving: false,
          hasChanges: false,
        });
      }
    });
  }
  onCancel = () => {
    this.prepopulateOutletInfo();
  };

  render() {
    const {
      outlets = [],
      outletId,
      device,
      loading,
      loaded,
      resources = {},
    } = this.props;

    const serial = device?.enclosureSerialNumber;
    const groupsLoading = resources?.groupsLoading;
    const groupsLoaded = resources?.groupsLoaded;

    const outletSelect = (
      <div className="cell ">
        <div
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <select
            value={outletId || ""}
            style={{
              margin: "0px",
            }}
            onChange={(e) => {
              const selectedOutletId = e.target.value;
              if (!serial) {
                return;
              }
              const basePath = `/devices/connected/${serial}/outlets`;
              if (selectedOutletId) {
                this.props.history.push(`${basePath}/${selectedOutletId}`);
              } else {
                this.props.history.push(basePath);
              }
            }}
            disabled={!serial}
          >
            <option value="">Select An Outlet</option>
            {(outlets || []).map((outlet) => (
              <option key={outlet.outlet_id} value={outlet.outlet_id}>
                Outlet {outlet.pduLabeledOutletNum}{" "}
                {outlet.outletName === `Outlet ${outlet.pduLabeledOutletNum}`
                  ? ""
                  : `- ${outlet.outletName}`}{" "}
                ({(outlet.currentRms || 0).toFixed(2)} A)
              </option>
            ))}
          </select>
        </div>
      </div>
    );

    const outlet = outlets.find((entry) => entry.outlet_id == outletId);

    if (!outlet) {
      return (
        <div className="grid-container">
          <div className="grid-x grid-padding-x grid-padding-y">
            {outletSelect}
            <div className="cell">
              {loading || !loaded ? (
                <Loading description="Loading outlet details..." />
              ) : (
                <div>No outlet data available for the selected outlet.</div>
              )}
            </div>
          </div>
        </div>
      );
    }

    const outletGroupsDetailed = this.getOutletGroupsForOutlet(
      outlet.outlet_id
    );
    const availableGroups = this.getAvailableOutletGroups(outlet.outlet_id);

    const supportsOutletMeasurements = Boolean(
      device?.outletPwrMeasurementsSupported &&
      serial &&
      outlet?.outlet_id
    );
    const outletSubtitle = (() => {
      const base = `Outlet ${outlet.pduLabeledOutletNum || outlet.outlet_id}`;
      if (
        outlet.outletName &&
        outlet.outletName !== `Outlet ${outlet.pduLabeledOutletNum}`
      ) {
        return `${base} – ${outlet.outletName}`;
      }
      return base;
    })();
    const outletGroupNames = this.getOutletGroupNames(outlet.outlet_id);
    const getGroupLabel = group =>
      group?.name || group?.groupName || `Group ${group?.id}`;
    const sortedAvailableGroups = [...availableGroups].sort((a, b) =>
      getGroupLabel(a).localeCompare(getGroupLabel(b))
    );
    const totalOutletGroups = (resources.groups || []).filter(
      (group) => group.groupType === "outlets"
    ).length;

    return (
      <div className="grid-container">
        <div className="grid-x grid-padding-x grid-padding-y">
          {outletSelect}
          {loading && loaded && (
            <div
              className="cell"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Loading size="16px" />
            </div>
          )}
          <div className="cell" style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
          }}>
            <h4  style={{ margin: "0px" }}>
              Outlet {outlet.pduLabeledOutletNum}{" "}
              {outlet.outletName ===
              `Outlet ${outlet.pduLabeledOutletNum}`
                ? ""
                : `- ${outlet.outletName}`}
            </h4>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                opacity: this.state.hasChanges ? 1 : 0,
              }}
            >
              <button
                className="button"
                style={{
                  backgroundColor: "#eee",
                  color: "#111",
                  marginRight: "10px",
                }}
                onClick={() => {
                  this.onCancel();
                }}
              >
                Cancel
              </button>
              <button
                className="button"
                onClick={() => {
                  if (!this.state.saving) {
                    this.onSave();
                  }
                }}
              >
                {this.state.saving ? <Loading /> : "Save"}
              </button>
            </div>
          </div>
          {supportsOutletMeasurements && (
            <div className="cell large-12">
              <DeviceLogChart
                title="Outlet Current RMS"
                subtitle={outletSubtitle}
                logType="outlets"
                enclosureSerialNumber={serial}
                resourceId={outlet.outlet_id}
                metricKey="currentRms"
                metricLabel="Current RMS"
                unit="A"
                color="#16a34a"
              />
            </div>
          )}
          <div className="cell large-6">
            <RowList
              rows={[
                {
                  label: "Outlet Stats",
                  labelStyle: {
                    fontWeight: "bold",
                    fontSize: "110%",
                  },
                },
                {
                  label: "Outlet State",
                  value: outlet.state,
                  valueStyle: {
                    color: outlet.state === "ON" ? "green" : "red",
                    fontWeight: "600",
                  },
                  onEdit: () => {
                    this.editOutletInfo(outlet, "state", "Outlet State", [
                      {
                        value: "ON",
                        label: "On",
                      },
                      {
                        value: "OFF",
                        label: "Off",
                      },
                      {
                        value: "REBOOT",
                        label: "Power Cycle/Reboot",
                      },
                    ]);
                  },
                },
                {
                  label: "Current RMS",
                  value:
                    outlet.currentRms !== undefined
                      ? `${outlet.currentRms.toFixed(2)} A`
                      : "-",
                },
                {
                  label: "Apparent Power",
                  value:
                    outlet.power !== undefined
                      ? `${outlet.power.toFixed(2)} VA`
                      : "-",
                },
                {
                  label: "Circuit Voltage",
                  value:
                    outlet.circuitVoltage !== undefined
                      ? `${outlet.circuitVoltage.toFixed(2)} V`
                      : "-",
                },
              ]}
            />
            <div style={{ margin: "20px" }}></div>
            <RowList
              rows={[
                {
                  label: "Outlet Information",
                  labelStyle: {
                    fontWeight: "bold",
                    fontSize: "110%",
                  },
                },
                {
                  label: "Outlet",
                  value: `Outlet ${outlet.pduLabeledOutletNum}`,
                },
                {
                  label: "Enclosure SN",
                  value: outlet.enclosureSerialNumber,
                },
                {
                  label: "Receptacle",
                  value: outlet.receptacle,
                },
                {
                  label: "Outlet ID",
                  value: outlet.outlet_id,
                },
                ...(Array.isArray(outletGroupNames) && outletGroupNames.length
                  ? [
                      {
                        label: "Outlet Groups",
                        valueComponent: (
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "6px",
                              width: "100%",
                            }}
                          >
                            {outletGroupNames.map((name, index) => (
                              <span
                                key={`${name}-${index}`}
                                className="device-badge"
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  padding: "2px 10px",
                                  borderRadius: "999px",
                                  backgroundColor: "#eef2ff",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  color: "#1f2937",
                                }}
                              >
                                {name}
                              </span>
                            ))}
                          </div>
                        ),
                      },
                    ]
                  : []),
                {
                  label: "Connection State",
                  value: outlet.connectionState,
                  valueStyle: {
                    fontWeight: "500",
                  },
                },
              ]}
            />
          </div>
          <div className="cell large-6">
            <TextInput
              label="Outlet Name"
              value={this.state.outletName}
              callback={(txt) => {
                this.setState({ outletName: txt, hasChanges: true });
              }}
            />
            <div style={{ marginBottom: "1rem" }}>
              <label
                style={{ fontWeight: 600, fontSize: "0.9rem", color: "#374151" }}
              >
                Outlet Groups
              </label>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "6px",
                  marginTop: "6px",
                  minHeight: "32px",
                }}
              >
                {groupsLoading && (
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                      fontSize: "0.85rem",
                      color: "#6b7280",
                    }}
                  >
                    <Loading size="14px" /> Loading groups...
                  </span>
                )}
                {!groupsLoading && outletGroupsDetailed.length === 0 && (
                  <span
                    style={{
                      fontSize: "0.85rem",
                      color: "#6b7280",
                    }}
                  >
                    Not assigned to any outlet groups yet.
                  </span>
                )}
                {outletGroupsDetailed.map((group) => {
                  const label = getGroupLabel(group);
                  const isMutating = this.isGroupMutating(group.id);
                  return (
                    <span
                      key={group.id}
                      className="device-badge"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        padding: "2px 10px",
                        borderRadius: "999px",
                        backgroundColor: "#eef2ff",
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#1f2937",
                      }}
                    >
                      <span>{label}</span>
                      <button
                        type="button"
                        aria-label={`Remove ${label} group`}
                        onClick={() => this.handleGroupRemove(group.id)}
                        disabled={isMutating}
                        style={{
                          background: "transparent",
                          border: "none",
                          marginLeft: "6px",
                          color: "#111827",
                          display: "inline-flex",
                          alignItems: "center",
                          cursor: isMutating ? "default" : "pointer",
                          padding: 0,
                        }}
                      >
                        {isMutating ? (
                          <Loading size="12px" />
                        ) : (
                          <i
                            className="material-icons"
                            style={{ fontSize: "14px", lineHeight: 1 }}
                          >
                            close
                          </i>
                        )}
                      </button>
                    </span>
                  );
                })}
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  alignItems: "center",
                  marginTop: "8px",
                }}
              >
                <select
                  value={this.state.addGroupSelection}
                  onChange={(e) => this.handleGroupSelectChange(e.target.value)}
                  disabled={
                    groupsLoading || sortedAvailableGroups.length === 0
                  }
                  style={{
                    minWidth: "200px",
                    padding: "6px 10px",
                    borderRadius: "6px",
                    border: "1px solid #d1d5db",
                    fontSize: "0.9rem",
                    marginBottom: "0px",
                  }}
                >
                  <option value="">
                    {groupsLoading
                      ? "Loading groups..."
                      : sortedAvailableGroups.length === 0
                      ? "No available groups"
                      : "Add to group..."}
                  </option>
                  {sortedAvailableGroups.map((group) => (
                    <option key={group.id} value={group.id}>
                      {getGroupLabel(group)}
                    </option>
                  ))}
                </select>
                {/* <button
                  type="button"
                  className="button secondary"
                  style={{ marginBottom: "0px" }}
                  onClick={() => this.openOutletGroupsModal(outlet)}
                >
                  Manage Groups
                </button> */}
              </div>
              {!groupsLoading &&
                groupsLoaded &&
                totalOutletGroups === 0 && (
                  <div
                    style={{
                      marginTop: "6px",
                      fontSize: "0.85rem",
                      color: "#6b7280",
                    }}
                  >
                    No outlet groups yet. Use "Manage Groups" to create one.
                  </div>
                )}
              {!groupsLoading &&
                sortedAvailableGroups.length === 0 &&
                outletGroupsDetailed.length > 0 && (
                  <div
                    style={{
                      marginTop: "6px",
                      fontSize: "0.85rem",
                      color: "#6b7280",
                    }}
                  >
                    Outlet already belongs to all available groups.
                  </div>
                )}
            </div>
            <TextInput
              label="Custom Field 1"
              value={this.state.customfield1}
              callback={(txt) => {
                this.setState({ customfield1: txt, hasChanges: true });
              }}
              maxLength={128}
              placeholder="Optional equipment identifier"
            />
            <TextInput
              label="Custom Field 2"
              value={this.state.customfield2}
              callback={(txt) => {
                this.setState({ customfield2: txt, hasChanges: true });
              }}
              maxLength={128}
              placeholder="Optional equipment identifier"
            />
            <SelectInput
              label="Power Up Initial State"
              info="After the PDU powers up from a cold boot, the outlet relay will switch to the Power Up Initial State. 'Previous' is the last known state before the shutdown occurred."
              value={this.state.pwrOnState}
              callback={(txt) => {
                this.setState({ pwrOnState: txt, hasChanges: true });
              }}
              options={[
                {
                  value: "ON",
                  label: "On",
                },
                {
                  value: "OFF",
                  label: "Off",
                },
                {
                  value: "PREV",
                  label: "Last Known State",
                },
              ]}
            />

            <ToggleInput
              label="Custom Reboot Time Enabled"
              description="Enable custom reboot time for this outlet when cycling power. Default global reboot time is 5 seconds, override with the following setting."
              value={this.state.customRebootTimeEnabled}
              type="checkbox"
              checked={this.state.customRebootTimeEnabled}
              callback={(status) => {
                this.setState({
                  customRebootTimeEnabled: status,
                  hasChanges: true,
                });
              }}
              id="custom-reboot-time-enabled"
            />

            <TextInput
              label="Custom Reboot Time"
              value={this.state.customRebootTime}
              description
              callback={(txt) => {
                this.setState({
                  customRebootTime: txt,
                  hasChanges: true,
                });
              }}
              type="number"
              placeholder="Enter Custom Reboot Time in seconds"
            />
            <div style={{ margin: "20px" }}></div>

            
          </div>
          <br />
          <br />
        </div>
      </div>
    );
  }
}

class EditOutletForm extends React.Component {
  state = {
    field: "",
    loading: false,
  };
  componentDidMount() {
    this.setState({
      field: this.props.outlet[this.props.field],
    });
  }
  render() {
    const { outlet, close } = this.props;

    return (
      <div>
        {this.props.options ? (
          <SelectInput
            label={this.props.fieldName || this.props.field}
            value={this.state.field}
            callback={(txt) => {
              this.setState({ field: txt });
            }}
            options={this.props.options}
          />
        ) : (
          <TextInput
            label={"Outlet " + this.props.fieldName || this.props.field}
            value={this.state.field}
            callback={(txt) => {
              this.setState({ field: txt });
            }}
            placeholder={
              "Enter Outlet " + this.props.fieldName || this.props.field
            }
          />
        )}
        <button
          className="button"
          onClick={() => {
            this.setState({ loading: true });
            this.props.updateOutlet(
              outlet.outlet_id,
              {
                [this.props.field]: this.state.field,
              },
              (err, res) => {
                this.setState({ loading: false });
                if (err) {
                  console.log(err);
                } else {
                  close();
                }
              },
              "id"
            );
          }}
        >
          {this.state.loading ? <Loading /> : "Change"}
        </button>
      </div>
    );
  }
}
